import { useCallback, memo, useMemo, useEffect, useRef } from "react";
import { useField } from "formik";

import RpMuiAutocompleteSelect from "@/components/muiCustom/select/RpMuiAutocompleteSelect";
import { doRRDPrintTypesMatch } from "@/features/campaigns/direct-mail/rrd/utils/rrdLayoutHelper";

export function getRRDMarketOptions(marketList = [], printType = "") {
  return marketList
    .filter((market) => doRRDPrintTypesMatch(market.print_type, printType))
    .map((market) => ({
      label: market.market,
      value: market.market,
    }));
}

function RRDDirectMarketInput({
  name = "market",
  printTypeFieldName = "print_type",
  marketList = [],
}) {
  const [marketField, , marketHelpers] = useField(name);
  const [printTypeField] = useField(printTypeFieldName);
  const previousPrintTypeRef = useRef(printTypeField.value);

  useEffect(() => {
    if (previousPrintTypeRef.current !== printTypeField.value) {
      marketHelpers.setValue("");
      previousPrintTypeRef.current = printTypeField.value;
    }
  }, [marketHelpers, printTypeField.value]);

  const options = useMemo(() => {
    return getRRDMarketOptions(marketList, printTypeField.value);
  }, [marketList, printTypeField.value]);

  const handleMarketChange = useCallback(
    (e, newValue) => {
      marketHelpers.setValue(newValue);
    },
    [marketHelpers]
  );

  return (
    <div>
      <RpMuiAutocompleteSelect
        options={options}
        value={marketField.value}
        onChange={handleMarketChange}
      />
    </div>
  );
}

export default memo(RRDDirectMarketInput);
